import { useEffect } from 'react'

const useCallbackOnTrue = (bool, callback) => {
    useEffect(() => {
        if (bool) {
            callback()
        }
    }, [bool, callback])
}

export default useCallbackOnTrue
